"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Styles = void 0;
const Colors_1 = require("./color/Colors");
const Fonts_1 = require("./font/Fonts");
const light_1 = require("./theme/light");
const dark_1 = require("./theme/dark");
const color_1 = require("./color");
class Styles {
    constructor(theme) {
        this.theme = theme;
        /**
         * Greyscale ramp clamped to the surface lightness. `scale=0` near black,
         * `scale=1` near bg color, invisible.
         */
        this.g = (scale, alpha = 1) => {
            const bgL = this.bg.fg.l;
            const farL = this.light ? 0.04 : 0.96;
            const l = farL + (bgL - farL) * scale;
            return new color_1.HslColor(0, 0, l, alpha).toString();
        };
        /** Same range as `g()` but tinted with the neutral hue. */
        this.gN = (scale, alpha = 1) => {
            const bgL = this.bg.fg.l;
            const farL = this.light ? 0.04 : 0.96;
            const l = farL + (bgL - farL) * scale;
            const tintFactor = 1 - Math.abs(scale - 0.5) * 2;
            const s = this.neutral.fg.s * tintFactor * 0.25;
            return new color_1.HslColor(this.neutral.fg.h, s, l, alpha).toString();
        };
        this.light = theme.light ?? true;
        this.col = new Colors_1.Colors(theme.color);
        this.txt = new Fonts_1.Fonts(theme.font);
        const lightSurface = color_1.HslColor.from('#F8F9FA');
        const darkSurface = color_1.HslColor.from('#1A1A1B');
        const surface = this.light ? lightSurface : darkSurface;
        const grey = new color_1.ThemeColor(new color_1.HslColor(0, 0, 0.5), lightSurface);
        const neutral = new color_1.ThemeColor(new color_1.HslColor(0.155, 0.43, 0.62), lightSurface);
        const accent = new color_1.ThemeColor(new color_1.HslColor(0.575, 0.91, 0.56), lightSurface);
        const accent2 = new color_1.ThemeColor(new color_1.HslColor(0.097, 0.85, 0.55), lightSurface);
        const positive = new color_1.ThemeColor(new color_1.HslColor(0.42, 0.69, 0.42), lightSurface);
        const negative = new color_1.ThemeColor(new color_1.HslColor(0.02, 0.75, 0.5), lightSurface);
        const important = new color_1.ThemeColor(new color_1.HslColor(0.75, 0.62, 0.55), lightSurface);
        const warning = new color_1.ThemeColor(new color_1.HslColor(0.105, 0.85, 0.5), lightSurface);
        const info = new color_1.ThemeColor(new color_1.HslColor(0.555, 0.8, 0.5), lightSurface);
        const ai = new color_1.ThemeColor(new color_1.HslColor(0.842, 0.75, 0.58), lightSurface);
        const link = new color_1.ThemeColor(new color_1.HslColor(0.717, 0.75, 0.55), lightSurface);
        this.bg = new color_1.ThemeColor(surface, surface);
        this.grey = this.light ? grey : grey.toDarkTheme(surface);
        this.neutral = this.light ? neutral : neutral.toDarkTheme(surface);
        this.accent = this.light ? accent : accent.toDarkTheme(surface);
        this.accent2 = this.light ? accent2 : accent2.toDarkTheme(surface);
        this.positive = this.light ? positive : positive.toDarkTheme(surface);
        this.negative = this.light ? negative : negative.toDarkTheme(surface);
        this.important = this.light ? important : important.toDarkTheme(surface);
        this.warning = this.light ? warning : warning.toDarkTheme(surface);
        this.info = this.light ? info : info.toDarkTheme(surface);
        this.ai = this.light ? ai : ai.toDarkTheme(surface);
        this.link = this.light ? link : link.toDarkTheme(surface);
    }
    toCssVars() {
        const out = {
            '--colTxtSharp': this.g(0.05, 0.95),
            '--colTxtLite': this.g(0.13, 0.87),
        };
        return out;
    }
}
exports.Styles = Styles;
Styles.make = (theme, dark) => new Styles(theme ?? (dark ? dark_1.theme : light_1.theme));
